import React, {useState} from 'react';
import bannerBg from '../assets/images/thumb/banner-bg.png'
import {Link} from "react-router";
import zeki  from "../assets/zeki.png";
import melek from "../assets/melek.png";
import onur  from "../assets/onur.png";
import sizmek from "../assets/sizmek.png";
import woman from "../assets/images/thumb/woman-banner.png"
import ceren from "../assets/ceren.png";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import {toast} from "react-toastify";
import {BiLoader} from "react-icons/bi";
import radyo1 from "../assets/radyo1.jpg"

function Home() {
    const [captcha, setCaptcha] = useState(false)
    const [sending, setSending] = useState(false)
    const [form, setForm] = useState({
        surename:"",
        name:"",
        phone:"",
        email:"",
        subject:"",
        message:"",
        address:"",
    })
    const sendMail = async (e) => {
        // eslint-disable-next-line no-unused-expressions
        e.preventDefault();
        setSending(true);
        const {name,email,subject,message} = form;
        if(name && email && subject && message){
            if(captcha){
                try{
                    const res = await axios.post('/mail.php', form, { headers: {'Content-Type': 'application/json'}})
                    if(res.data.msg){
                        toast.success(res.data.msg)
                    }
                    setSending(false);
                } catch (err){
                    toast.error('Bir şeyler yanlış.')
                    console.log(err)
                    setSending(false);
                }
            }else{
                toast.error('Lütfen gerçek insan olduğunuzu onaylayın.')
                setSending(false);
            }
        }else{
            toast.warn('Lütfen istenilen alanları doldurunuz!')
            setSending(false);
        }
    }


    return (
        <React.Fragment>
            <section
                className="banner pt-120 bg-img"
                id="ana-sayfa"
                style={{backgroundImage: `url(${bannerBg})`}}
            >
                <div
                    id="ana-sayfa-div"
                    className="banner-thumb bg-img top-center"
                    style={{backgroundImage: "url(../assets/images/thumb/banner-img.png)"}}
                ></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="banner-content">
                                <h1 className="banner-content__title">
            <span className="banner-content__title-icon">
              <span className="icon-wifi"/>
            </span>{" "}
                                    <span className="banner-content__title">AUDIOTIME</span><br/>
                                    <span className="banner-content__title-colored">TÜRKİYE'NİN</span>
                                    &nbsp;&nbsp; <span className="banner-content__title">EN BÜYÜK</span>
                                    &nbsp;&nbsp; <span
                                    className="banner-content__title-colored">radio networkü</span>{" "}
                                </h1>
                                <p className="banner-content__desc">
                                    Yapay zeka destekli dijital radyo reklamcılığı
                                </p>
                                <ul className="button-list mt-5">
                                    <li className="button-list__item">
                                        <Link
                                            to="/hakkimizda"
                                            className="button-list__link btn--base style-two"
                                            reloadDocument
                                        >
                                            HAKKIMIZDA{" "}
                                            <span className="btn--base__icon">
                  <span className="icon-play-button-4-1"/>{" "}
                </span>{" "}
                                        </Link>
                                    </li>
                                    <li className="button-list__item">
                                        <Link
                                            to="/iletisime-gecin"
                                            className="button-list__link btn--base outline"
                                            reloadDocument
                                        >
                                            İLETİŞİME GEÇİN{" "}
                                            <span className="btn--base__icon">
                  <span className="icon-next"/>
                </span>{" "}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                {/* ======== live Youtube Start Here ====== */}

                {/* ======== live Youtube End Here ======== */}
            </section>


            <section className="about-us py-120">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-md-7 pe-lg-5">
                            <div className="about-left">
                                <div className="about-left__thumbs">
                                    <img src="assets/images/thumb/about-img-01.png" alt=""/>
                                    <img src="assets/images/thumb/about-img-02.png" alt=""/>
                                </div>
                                <div className="about-24">
                                    <span className="about-24__text">24+</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="about-content">
                                <div className="section-heading style-two">
                                    <h5 className="section-heading__subtitle">
                                        <span className="section-heading__bars lightBar bars-one"/> Hakkımızda{" "}
                                        <span className="section-heading__bars lightBar bars-two"/>
                                    </h5>
                                    <h2 className="section-heading__title">
                                        <span className="section-heading__title-colored"> Audiotime</span>{" "}
                                    </h2>
                                    <p className="section-heading__desc">

                                        Audiotime, Türkiye’nin önde gelen ses yayıncılarına reklam vermenizi sağlayan
                                        bir dijital audio ve karasal radyo reklam satış evidir. Türkiye’de dijital
                                        audio reklam pazarının oluşturulmasında öncü olmuş, karasal radyo pazarına
                                        hakim profesyonel bir kadroya sahip olan Audiotime, sektörde sınanmış
                                        tecrübesine ek olarak yeni nesil teknolojiler ile radyo ve ses reklamcılığının
                                        en inovatif projelerine imza atmayı hedeflemektedir.
                                    </p>
                                </div>
                                {/*<div className="about-info">*/}
                                {/*    <div className="about-info__thumb">*/}
                                {/*        <img src="assets/images/thumb/about-img.png" alt="" />*/}
                                {/*    </div>*/}
                                {/*    <div className="about-info__details">*/}
                                {/*        <h5 className="about-info__name">Transport Signal</h5>*/}
                                {/*        <span className="about-info__designation">CEo,Fmlab</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ============================ About Us End ========================*/}
            <section className="py-120 justify-content-center" style={{textAlign: "center"}}>
                <div className="container">
                    <div className="row gy-4 justify-content-center">
                        <div className="col-md-12 justify-content-center">
                            <h2 className="section-heading__title justify-content-center">
                                <span
                                    className="section-heading__title-colored">Türkiye'nin En Büyük Dijital Radyo Networkü</span>{" "}
                            </h2>
                            <p className="section-heading__desc">Networkümüzdeki Yayıncılar
                            </p>
                            <p className="section-heading__desc">Toplam 9.600.000 Tekil Dinleyici</p>
                        </div>
                    </div>
                    <div
                        className="py-4"
                        data-mesh-id="comp-m17mircj1inlineContent-gridContainer"
                        data-testid="mesh-container-content"
                    >


                        <div id="comp-m5mjs2nu" className="MazNVa comp-m5mjs2nu wixui-image">
                            <div data-testid="linkElement" className="j7pOnl">
                                <img
                                    loading="lazy"
                                    sizes="716px"
                                    srcSet="https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_716,h_118,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/haber%20envanteri.png 1x, https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_1303,h_215,al_c,lg_1,q_85,enc_avif,quality_auto/haber%20envanteri.png 2x"
                                    id="img_comp-m5mjs2nu"
                                    src="https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_716,h_118,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/haber%20envanteri.png"
                                    alt="haber envanteri.png"
                                    className="BI8PVQ Tj01hh"
                                    width={716}
                                    height={118}
                                    style={{objectFit: "cover"}}
                                />
                            </div>
                        </div>

                        <div id="comp-m5mjssfl" className="MazNVa comp-m5mjssfl wixui-image">
                            <div data-testid="linkElement" className="j7pOnl">
                                <img
                                    loading="lazy"
                                    sizes="979px"
                                    srcSet={`${radyo1} 2x`}
                                    id="img_comp-m5mjssfl"
                                    src={radyo1}
                                    alt="radyolar 1.png"
                                    className="BI8PVQ Tj01hh"
                                    width={979}
                                    height={508}
                                    style={{objectFit: "cover"}}
                                />
                            </div>
                        </div>
                        <div id="comp-m5uuub0v" className="MazNVa comp-m5uuub0v wixui-image">
                            <div data-testid="linkElement" className="j7pOnl">
                                <img
                                    loading="lazy"
                                    sizes="973px"
                                    srcSet="https://static.wixstatic.com/media/48b701_68f8dc46ff4b42a48bd54d9e41d59527~mv2.jpg/v1/fill/w_825,h_440,al_c,q_85,enc_avif,quality_auto/radyolar%206.jpg 1x, https://static.wixstatic.com/media/48b701_68f8dc46ff4b42a48bd54d9e41d59527~mv2.jpg/v1/fill/w_825,h_440,al_c,q_85,enc_avif,quality_auto/radyolar%206.jpg 2x"
                                    id="img_comp-m5uuub0v"
                                    src="https://static.wixstatic.com/media/48b701_68f8dc46ff4b42a48bd54d9e41d59527~mv2.jpg/v1/fill/w_825,h_440,al_c,q_85,enc_avif,quality_auto/radyolar%206.jpg"
                                    alt="radyolar 6.jpg"
                                    className="BI8PVQ Tj01hh"
                                    width={973}
                                    height={519}
                                    style={{objectFit: "cover"}}
                                />
                            </div>
                        </div>


                    </div>


                </div>
            </section>
            <section className="faq py-120">
                <div className="container">
                    <div className="row gy-4 align-items-start align-items-lg-center">
                        <div className="col-lg-5 col-lg-6">
                            <div className="section-heading style-two">
                                <h5 className="section-heading__subtitle">
                                    <span className="section-heading__bars lightBar bars-one"/> Hefefleme{" "}
                                    <span className="section-heading__bars lightBar bars-two"/>
                                </h5>
                                <h2 className="section-heading__title">
                                    {" "}
                                    <span className="section-heading__title-colored">Doğru Ses, </span>{" "} Doğru
                                    Kulağa

                                </h2>
                                <p className="section-heading__desc">
                                    Dijital ses reklamcılığı, hedef kitlenize “Doğru Ses” ile ulaşarak onlarla kişisel
                                    ve etkili bağ kurmanın en güçlü yollarından biridir. Platformlar, yaş, cinsiyet,
                                    coğrafi konum, ilgi alanları, cihaz kullanımı ve dinleyici davranışları gibi detaylı
                                    kriterlerle reklamlarınızı hassas şekilde yönlendirmenize olanak sağlar . Hedefleme
                                    seçenekleri arasında günün belirli saatlerinde yayınlanan zamanlama stratejileri,
                                    mobil kullanıcılar veya akıllı hoparlör sahipleri gibi cihaz odaklı hedeflemeler ve
                                    önceki etkileşimlere göre yeniden hedefleme (retargeting) stratejileri de bulunur .
                                    <p/>
                                    Dinleyici alışkanlıkları, müzik türleri, podcast tercihi ve gerçek zamanlı veriler
                                    (örneğin hava durumu), kampanyaların bağlam ve zamana uygun şekilde dinamik olarak
                                    özelleştirilmesine imkan tanır.
                                    <p/>
                                    Bu sayede reklam mesajları, dinleyicinin o andaki ruh haliyle uyumlu hale gelir.
                                    Ayrıca, dijital ses reklamları daha fazla dikkat çekmekte ve harekete geçirmede
                                    ekranlı reklamlara kıyasla daha yüksek dönüşüm oranları sunmaktadır: reklam
                                    hatırlanması %24 daha fazla ve satın alma niyeti ortalama iki kat daha yüksek.
                                    <p/>
                                    Üstelik dijital ses, geleneksel radyoya kıyasla daha uygun maliyetli, kolay
                                    ölçümlenebilir ve gerçek zamanlı performans optimizasyonu sunar . Kullanıcıların
                                    çoğu diğer ortamlarla meşgul olmadığından dinleyici dikkatini doğrudan reklamınıza
                                    yönlendirebilirsiniz .
                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6 col-lg-6 ps-lg-5">
                            <div className="accordion-right">
                                <div className="accordion-right__thumb">
                                    <img src="assets/images/thumb/about-img-01.png" alt="sizmek"/>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ==================== Team Start Here ==================== */}
            <section className="faq py-120">
                <div className="container">
                    <div className="row gy-4 align-items-start align-items-lg-center">
                        <div className="col-lg-5 col-lg-6">
                            <div className="section-heading style-two">
                                <h5 className="section-heading__subtitle">
                                    <span className="section-heading__bars lightBar bars-one"/> GÜVENİLİRLİK{" "}
                                    <span className="section-heading__bars lightBar bars-two"/>
                                </h5>
                                <h2 className="section-heading__title">
                                    {" "}
                                    <span className="section-heading__title-colored">Audiotime</span>{" "} Dijital
                                    Network

                                </h2>
                                <p className="section-heading__desc">
                                    Güvenilir Ölçüm ve İleri Düzey Hedefleme Seçenekleri
                                    <br/><br/>
                                    Güvenilir Ölçüm ve İleri Düzey Hedefleme Seçenekleri

                                    <br/><br/>

                                    100’lerce Radyo 21 milyon farklı ip üzerinden duplikasyonlardan arındırılmış 9
                                    milyon+ tekil dinleyici ve 155 milyondan fazla oturum ile hedef kitlenize ulaşın.

                                    <br/><br/>

                                    Dünyanın en iyi reklam teknolojilerini sağlayan firmalarla partneriz. Bu
                                    teknolojiler ile reklamverenlerimize ileri düzey hedeflemeler, anlık raporlamalar ve
                                    güvenilir ölçümleme sağlıyoruz.
                                    <br/>
                                    <br/>
                                    Sunucularımız “SIZMEK by Amazon” Sertifikasyonuna sahiptir.
                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6 col-lg-6 ps-lg-5">
                            <div className="accordion-right">
                                <div className="accordion-right__thumb">
                                    <img src={sizmek} alt="sizmek"/>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                className="team-and-counter py-120 bg-img"
                style={{backgroundImage: "url(./assets/images/thumb/team-bg.png)", backgroundColor: "#0a0a0a"}}
            >
                <div className="team-bottom-thumb">
                    <img src="assets/images/thumb/footer-bid.png" alt=""/>
                </div>
                {/* Team Start */}
                <div className="team-wrapper">
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-12">
                                <div className="section-heading style-two">
                                    <h5 className="section-heading__subtitle" style={{color: "#fff"}}>
                                        <span className="section-heading__bars bars-one"/> EKİP{" "}
                                        <span className="section-heading__bars bars-two"/>
                                    </h5>
                                    <h2 className="section-heading__title" style={{color: "white"}}>
                                        {" "}
                                        <span className="section-heading__title-colored">
                 AUDIOTIME
                </span>{" "} AİLESİ
                                    </h2>

                                </div>
                            </div>
                        </div>
                        <div
                            className="row team-item-wrapper dots-right-top margin-in-slider justify-content-center gy-4">
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={melek} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Melek Doyan Etik
                                        </span>{" "}
                                        <span className="team-item__title-colored">Managing Partner</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={zeki} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Zeki Gültekin
                                        </span>{" "}
                                        <span className="team-item__title-colored">Managing Partner</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={ceren} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Ceren Dinlergüler
                                        </span>{" "}
                                        <span className="team-item__title-colored">Advertising Sales Manager</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            <div className="team-item">
                                <div className="team-item__thumb">
                                    <img src={onur} alt=""/>
                                    <h4 className="team-item__title">
                                        <span className="team-item__title-link">
                                            Onur Kavran
                                        </span>{" "}
                                        <span className="team-item__title-colored">Reservation Manager</span>{" "}
                                    </h4>
                                </div>
                            </div>
                            {/*<div className="team-item">*/}
                            {/*    <div className="team-item__thumb">*/}
                            {/*        <img src="assets/images/thumb/team-img-02.png" alt="" />*/}
                            {/*        <div className="team-item__socails">*/}
                            {/*            <ul className="social-list">*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.facebook.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        <span className="icon-facebook" />*/}
                            {/*                    </a>{" "}*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.twitter.com"*/}
                            {/*                        className="social-list__link active"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-twitter" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.linkedin.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-linkedin" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*                <li className="social-list__item">*/}
                            {/*                    <a*/}
                            {/*                        href="https://www.pinterest.com"*/}
                            {/*                        className="social-list__link"*/}
                            {/*                    >*/}
                            {/*                        {" "}*/}
                            {/*                        <span className="icon-pinterest" />*/}
                            {/*                    </a>*/}
                            {/*                </li>*/}
                            {/*            </ul>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                        </div>
                    </div>
                </div>
                {/* team End */}
            </section>
            <section className="contact-wrapper">
                <ul className="contact-img-list">
                    <li className="contact-img-list__item">
                        <img src={woman} alt=""/>
                    </li>
                    <li className="contact-img-list__item">

                    </li>
                </ul>
                <div className="contact-top pt-120 pb-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="section-heading style-two">
                                    <h2 className="section-heading__title"> BİZİMLE İLETİŞİME GEÇİN</h2>

                                </div>
                                <div className="row gy-5">
                                    <div className="col-sm-6">
                                        <div className="contact-content">
                                            <div className="contact-content__icon">
                                                <span className="icon-pin1"/>
                                            </div>
                                            <div className="contact-content__address">
                                                <h5 className="contact-content__title">Adres</h5>
                                                <p className="contact-content__desc">
                                                    Ayazağa mah Azerbaycan cad 2B No:3K İç Kapı No 13
                                                </p>
                                                <p className="contact-content__desc">Sarıyer/İstanbul, Turkey</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="contact-content">
                                            <div className="contact-content__icon">
                                                <span className="icon-chat"/>
                                            </div>
                                            <div className="contact-content__address">
                                                <h5 className="contact-content__title">E-mail</h5>
                                                <p className="contact-content__desc">
                                                    digital@audiotime.com.tr
                                                </p>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contact-messsage pt-60 pb-120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                {/* Comment Form Start */}
                                <div className="faq-comment-form mt-lg-5 mt-4 pt-4 pt-lg-2">
                                    <form action="#" autoComplete="off">
                                        <h3 className="comment-form__title">SORULARINIZ İÇİN </h3>
                                        <div className="row gy-md-4 gy-3">
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form--control"
                                                    placeholder="İsim*"
                                                    value={form.name}
                                                    onChange={e => setForm(prevState => ({
                                                        ...prevState,
                                                        name: e.target.value
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="email"
                                                    className="form--control"
                                                    placeholder="Email Adresi*"
                                                    value={form.email}
                                                    onChange={e => setForm(prevState => ({
                                                        ...prevState,
                                                        email: e.target.value
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form--control"
                                                    placeholder="Telefon numaranızı girin"
                                                    value={form.phone}
                                                    onChange={e => setForm(prevState => ({
                                                        ...prevState,
                                                        phone: e.target.value
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="Adres"
                                                    className="form--control"
                                                    placeholder="Adres Girin"
                                                    value={form.address}
                                                    onChange={e => setForm(prevState => ({
                                                        ...prevState,
                                                        address: e.target.value
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <input
                                                    type="Konu"
                                                    className="form--control"
                                                    placeholder="Konuyu yazın"
                                                    value={form.subject}
                                                    onChange={e => setForm(prevState => ({
                                                        ...prevState,
                                                        subject: e.target.value
                                                    }))}
                                                />
                                            </div>
                                            <div className="col-sm-12">

                  <textarea
                      className="form--control"
                      placeholder="Mesajınızı buraya yazın..."
                      defaultValue={""}
                      value={form.message}
                      onChange={e => setForm(prevState => ({...prevState, message: e.target.value}))}
                  />
                                            </div>
                                            <div className="col-sm-12 justify-content-center">
                                                <ReCAPTCHA
                                                    sitekey="6LfUsWkrAAAAAAX2kh02uO82lmDWHJzE56H6Pp0_"
                                                    onChange={e => setCaptcha(e)}
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <button className="btn--base style-two w-100" onClick={sendMail}>
                                                    {sending ? <BiLoader className="rotating"/> : "GÖNDER"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* Comment Form End */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="contact-map">
                <iframe
                    className="contact-map__iframe"
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3006.3600137834283!2d28.98443217604539!3d41.10482787133713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDA2JzE3LjQiTiAyOMKwNTknMTMuMiJF!5e0!3m2!1sen!2suk!4v1750254862465!5m2!1sen!2suk"
                    width={600}
                    height={450}
                    style={{border: 0}}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"/>
            </div>


        </React.Fragment>

    );
}

export default Home;